import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { initTheme } from "@/app/theme";
import "@/index.css";

// BEFORE React renders, so the page never flashes the wrong theme. A class on
// <html> rather than a state flag: the tokens live in CSS and the first paint
// has to have them.
initTheme();

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");
createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
